
export default {
    state: {
        list: require('../../data/people.json').people
    },
    mutations: {
        setPeople(state, people) {
            state.list = people;
        }
    },
    getters: {
        people(state) {
            return state.people.list;
        }
    }
};



// WEBPACK FOOTER //
// ./src/script/model/people.js